import React, { Component } from 'react';
import { connect } from 'react-redux';
import Glide, {
  Controls,
  Breakpoints
} from '@glidejs/glide/dist/glide.modular.esm';
import './myplan.css';
import Item from './item';
import { createRef } from 'react';
import {Button} from "react-bootstrap";
import * as axios from "axios";

class Table extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalref: createRef(),
      slider: new Glide('.glide', {
        type: 'slider',
        animationDuration: 150,
        rewind: false,
        startAt: this.props.dayIndex,
        perView: 1
      })
    };
    this.changeDay = this.changeDay.bind(this);
    this.addD = this.addD.bind(this);
  }
  componentDidMount() {
    setTimeout(() => {
      this.state.slider.mount({ Controls, Breakpoints });
    }, 500);
  }
  changeDay(day) {
    this.state.modalref.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
    if (day > -1 && day < this.props.days ) {
      this.props.changeDay(day);
      this.state.slider.go(`=${day}`);
    }
  }
  addD() {
    this.props.addDays();
    setTimeout(() => {
      this.setState({
        slider: new Glide('.glide', {
          type: 'slider',
          animationDuration: 100,
          rewind: false,
          dragThreshold: 120,
          swipeThreshold: 80,
          startAt: this.props.dayIndex,
          perView: 1
        })
      });
      this.state.slider.mount({ Controls, Breakpoints });
    }, 500);
  }
  reduceD() {
    this.props.reduceDays();
    setTimeout(() => {
      this.setState({
        slider: new Glide('.glide', {
          type: 'slider',
          animationDuration: 100,
          rewind: false,
          dragThreshold: 120,
          swipeThreshold: 80,
          startAt:
            this.props.dayIndex >= this.props.list.length
              ? this.props.list.length - 1
              : this.props.dayIndex,
          perView: 1
        })
      });
      this.state.slider.mount({ Controls, Breakpoints });
      this.props.changeDay(
        this.props.dayIndex >= this.props.list.length
          ? this.props.list.length - 1
          : this.props.dayIndex
      );
    }, 500);
  }

  moveGlide(id) {
    this.state.slider.go(`=${id}`);
    this.props.changeDay(id);
  }
  setLeterDay(i) {
    switch (i) {
      case 1:
        return 'L';
      case 2:
        return 'M';
      case 3:
        return 'X';
      case 4:
        return 'J';
      case 5:
        return 'V';
      case 6:
        return 'S';
      case 7:
        return 'D';
      default:
        return 'L';
    }
  }
  setNameDay(i) {
    switch (i) {
      case 1:
        return 'Lunes';
      case 2:
        return 'Martes';
      case 3:
        return 'Miércoles';
      case 4:
        return 'Jueves';
      case 5:
        return 'Viernes';
      case 6:
        return 'Sábado';
      case 7:
        return 'Domingo';
      default:
        return 'Lunes';
    }
  }
  createIconsBullet() {
    var items = [];
    for (let i = 0; i < this.props.list.length; i++) {
      items.push(
        <div
          className={this.props.dayIndex === i ? 'bullet active' : 'bullet'}
          onClick={() => this.moveGlide(i)}>
          {this.setLeterDay(i + 1)}
        </div>
      );
    }
    return items;
  }
  resetRutine() {
    const id = parseInt(localStorage.getItem("userRestricId")) || 0;
    const plan = [{id: 1, items: []}, {id: 2, items: []}, {id: 3, items: []}, {id: 4, items: []}, {id: 5, items: []}];
    if (id !== 0) {
      axios.post("https://fullmusculo.com/api/personal_routine",
          {
            data: { user: localStorage.getItem("userRestricId"), content: plan },
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
      )
          .then((res) => {})
          .catch((err) => console.log(err));
    }
    localStorage.removeItem("plan")
    localStorage.removeItem("endplan")
    this.props.setPersonalPlan(plan)
  }
  render() {
    return (
      <>
        <div className='glide__arrows' data-glide-el='controls'>
          <button
              onClick={() => this.changeDay(this.props.dayIndex - 1)}
              className='glide__arrow glide__arrow--left'
              data-glide-dir='<'
              style={{ border: 'none' }}>
            <i
                className='fas fa-chevron-left'
                style={{ fontSize: '30px' }}></i>
          </button>
          <div>

            <div ref={this.state.modalref} style={{margin: '10px', marginBottom: '12px'}}>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <i
                    onClick={() => this.reduceD()}
                    className='fas fa-minus'
                    style={{
                      padding: '5px 0',
                      color: this.props.days === 1 ? '#cecece' : null
                    }}></i>
                <label style={{ display: 'flex',alignItems:'center',marginBottom:'0px' }}>
                  {this.createIconsBullet()}
                </label>
                <i
                    onClick={() => this.addD()}
                    className='fas fa-plus'
                    style={{
                      padding: '5px 0',
                      paddingRight: 0,
                      color: this.props.days === 7 ? '#cecece' : null
                    }}></i>
              </div>
            </div>
          </div>
          <button
              onClick={() => this.changeDay(this.props.dayIndex + 1)}
              className='glide__arrow glide__arrow--right'
              data-glide-dir='>'
              style={{ border: 'none' }}>
            <i
                className='fas fa-chevron-right'
                style={{ fontSize: '30px' }}></i>
          </button>
        </div>
        <div className={"reset_rutine"}>
          <div onClick={() => this.resetRutine()}><i className={"far fa-trash-alt"}></i>Reiniciar rutina</div>
        </div>
        <div className='glide'>
          <div className='glide__track' data-glide-el='track'>
            <ul className='glide__slides '>
              {this.props.list.map((list, index) => (
                <li key={index} className={`glides${index} glide__slide`}>
                  <div
                    className='card day col-12'
                    style={{ paddingLeft: '1px', paddingRight: '1px' }}>
                    <h6 style={{ margin: '.5rem 0px', marginBottom: '0px' }}>
                      {this.setNameDay(list.id)}
                    </h6>
                    <div
                      className='container list-day'>
                      {list.items.map((ejercice, i) => (
                        <Item
                          ejercice={ejercice}
                          key={i}
                          colum={list.id}
                          id={list.id + '-' + i}
                          index={i}
                        />
                      ))}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* */}
        </div>
      </>
    );
  }
}
const mapStateToProps = state => ({
  dayIndex: state.dayIndex,
  days: state.days
});
const mapDispatchToProps = dispatch => ({
  setPersonalPlan(plan) {
    dispatch({
      type: "SET_PLAN",
      plan: plan,
    });
  },
  reduceDays() {
    dispatch({
      type: 'REDUCE_DAYS'
    });
  },
  addDays() {
    dispatch({
      type: 'ADD_DAYS'
    });
  },
  changeDay(day) {
    dispatch({
      type: 'CHANGE_DAY',
      day: day
    });
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(Table);
